<template>
  <div>
    <div class="tone-of-voice-button" :class="{active}" :data-tone="value">
      <div>
        <p>
          <img :src="icon" :alt="visualLabel"/> <br>
          <strong>{{ visualLabel }}</strong>
        </p>
        <div class="
            uk-flex-between
            uk-child-width-1-1
            uk-child-width-2-5@s
            uk-grid-row-small"
             uk-grid>
          <div>
            <button type="button"
                    @click="toggleAudioHard"
                    class="uk-button uk-width-1-1 uk-button-small uk-button-primary">
              {{ playText }}
            </button>
          </div>
          <div>
            <button type="button"
                    @click="toggleSelect"
                    class="uk-button uk-width-1-1 uk-button-small uk-button-primary selector"
            >
              {{ selectText }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AudioElement from '@/mixins/AudioElement';

export default {
  name: 'ToneOfVoiceSelectorButton',
  mixins: [new AudioElement()],
  props: {
    value: String,
    label: {
      type: String,
      required: false,
    },
    selected: {
      type: Boolean,
      default: false,
    },
    icon: String,
  },
  data() {
    return {
      active: this.selected,
      visualLabel: this.label ?? this.value,
    };
  },
  computed: {
    playText() {
      return this.playing ? 'Stop' : '▸ Luister';
    },
    selectText() {
      return this.active ? 'Deselecteer' : 'Selecteer';
    },
  },
  methods: {
    toggleSelect() {
      this.$emit('click', this);
    },
  },
};
</script>
